import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Menu, MenuItem, IconButton, Button, Box } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  LocalizationDataGridConst,
  tableFilterProperty,
} from "./LocalizationDataGrid";
import { useLanguageContext } from "../../../Context/LanguageContext";
import TextField from "@mui/material/TextField";
import {
  DataGridPro,
  GridFilterPanel,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { parse, format } from "date-fns";
import dateFormat from "dateformat";
import dayjs from "dayjs";
import { _helper } from "../../GlobalFunction/dateHelper";
import CustomDataGridDateHelper from "./DatePickerHelper";
import { PageHeader } from "../../MuiOverRideComponent/PageHeader";
// function DateInputValue(props) {
//   const { item, applyValue, focusElementRef } = props;
//   const [value, setValue] = React.useState(
//     item.value ? dayjs(item.value) : null
//   );

//   React.useImperativeHandle(focusElementRef, () => ({
//     focus: () => {},
//   }));

//   const handleFilterChange = (newValue) => {
//     if (dayjs(newValue).isValid()) {
//       setValue(newValue);
//       applyValue({ ...item, value: newValue.toISOString() }); // Ensure the value is ISO string
//     } else {
//       setValue(null);
//       applyValue({ ...item, value: null }); // Handle null case
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <DatePicker
//         label="Value"
//         value={value}
//         onChange={handleFilterChange}
//         renderInput={(params) => <TextField {...params} variant="standard" />}
//         inputFormat={_helper.DateFormateOrganization(true)}
//         ref={focusElementRef}
//       />
//     </LocalizationProvider>
//   );
// }

// const dateCreatedOperators = [...CustomDataGridDateHelper(DateInputValue)];

const CustomDataGrid = ({
  Title,
  columns,
  rows,
  operations,
  onAdd,
  showExport,
  showColumns,
  showFilters,
  showDensity,
  visibleColumns,
  showCheckBox = true,
  columnStyles = [],
  handleCellStyle = () => {},
  booleanField = [],
  trackMultipleAction,
  setTrackMultipleAction,
  gridTableHeight,
  gridFilter = null,
  renderParentComponent = null,
  handleSelectionChange,
}) => {
  const { localization } = useLanguageContext();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);
  const [selectedRowIds, setSelectedRowIds] = React.useState([]);
  const [showToolbar, setShowToolbar] = React.useState(true); // State to manage toolbar visibility

  const handleMenuOpen = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(rowData.row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };
  React.useEffect(() => {
    if (trackMultipleAction) {
      setSelectedRowIds(trackMultipleAction);
      setTrackMultipleAction(null);
    }
  }, [trackMultipleAction]);

  const tableHeader = (
    <div>
      {/* Title on the Left */}
      <div className="row w-100 ml-0 mr-0">
        <div className="col-4">
          <PageHeader Title={Title} />
        </div>{" "}
        <div className="col d-flex justify-content-end">
          <GridToolbarQuickFilter
            style={{ marginLeft: "auto", width: "70%" }}
          />
        </div>
      </div>
      <div className="row w-100 ml-0 mr-0">
        {renderParentComponent && (
          <div className="col-4">{renderParentComponent}</div>
        )}
      </div>
      {/* Quick Filter on the Right */}
    </div>
  );
  const GridToolbarButton = () => (
    <>
      {tableHeader}
      <GridToolbarContainer id="mainGridButton">
        <div>
          {" "}
          {showColumns && (
            <GridToolbarColumnsButton
              disabled={rows.length === 0}
              componentsprops={{
                tooltip: {
                  componentsprops: {
                    root: {
                      component: "span",
                    },
                  },
                },
              }}
            />
          )}
          {showFilters && (
            <GridToolbarFilterButton
              disabled={rows.length === 0}
              componentsprops={{
                tooltip: {
                  componentsprops: {
                    root: {
                      component: "span",
                    },
                  },
                },
              }}
            />
          )}
          {showDensity && (
            <GridToolbarDensitySelector
              disabled={rows.length === 0}
              componentsprops={{
                tooltip: {
                  componentsprops: {
                    root: {
                      component: "span",
                    },
                  },
                },
              }}
            />
          )}
          {showExport && (
            <GridToolbarExportContainer>
              <GridCsvExportMenuItem disabled={rows.length === 0} />
            </GridToolbarExportContainer>
          )}
          {/* <GridToolbarQuickFilter /> */}
          {gridFilter}
        </div>
        <div style={{ marginLeft: "auto" }} className="d-flex">
          {operations["GridToolBarAction"] &&
            operations["GridToolBarAction"].map((action, index) => (
              <div key={index} onClick={action.onClick}>
                {action.component}
              </div>
            ))}
        </div>
      </GridToolbarContainer>
    </>
  );

  const CustomToolBar = () => (
    <>
      {tableHeader}
      <GridToolbarContainer
        className="rowSelectToolBar"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div>
          {selectedRowIds.length > 0 && (
            <span className="ml-5">{`${selectedRowIds.length} ${localization.noRowSelected}`}</span>
          )}
        </div>
        <div style={{ display: "flex" }}>
          {selectedRowIds.length > 0
            ? operations["SelectedToolBar"] &&
              operations["SelectedToolBar"].map((actions, index) => (
                <div
                  key={index}
                  onClick={() => {
                    actions.onClick(selectedRowIds);
                  }}
                  id={`${actions.label === "Delete" && "dangerDelete"}`}
                >
                  {actions.component}
                </div>
              ))
            : operations["GridToolBarAction"].map((action, index) => (
                <div key={index} onClick={action.onClick}>
                  {action.component}
                </div>
              ))}
        </div>
      </GridToolbarContainer>
    </>
  );

  // const renderCellWithActions = (params) => (
  //   <Box
  //     display="flex"
  //     justifyContent="space-between"
  //     alignItems="center"
  //     width="100%"
  //   >
  //     <span
  //       style={{
  //         whiteSpace: "normal",
  //         wordBreak: "break-word",
  //       }}
  //     >
  //       {params.value}
  //     </span>
  //     <IconButton
  //       aria-label="more"
  //       onClick={(event) => handleMenuOpen(event, params)}
  //     >
  //       <MoreVertIcon />
  //     </IconButton>
  //   </Box>
  // );

  // const enhancedColumns = columns
  //   .filter((column) => visibleColumns.includes(column.field))
  //   .map((column, index) => {
  //     const _tempColDef = {
  //       ...column,
  //       flex: 1,
  //       cellClassName: "customizeGridCellStyle",

  //       renderCell: (params) => {
  //         if (columnStyles.length > 0 && columnStyles.includes(params.field)) {
  //           //   return handleCellStyle(params.field, params.row);
  //         } else if (index === 0) {
  //           //    return renderCellWithActions(params);
  //         } else {
  //           if (
  //             params["colDef"].type === "date" &&
  //             params.value instanceof Date
  //           ) {
  //             return (
  //               <span title={params.value} className="tableCellTextStyle">
  //                 {format(params.value, _helper.DateFormateOrganization(true))}
  //               </span>
  //             );
  //           }
  //           return (
  //             <span title={params.value} className="tableCellTextStyle">
  //               {params.value}
  //             </span>
  //           );
  //         }
  //       },
  //     };
  //     if (column.type === "date") {
  //       return {
  //         ..._tempColDef,
  //         filterOperators: dateCreatedOperators,
  //         valueGetter: (params) => {
  //           // Convert date string to Date object
  //           if (params.value) {
  //             return parse(
  //               params.value,
  //               _helper.DateFormateOrganization(true),
  //               new Date()
  //             );
  //           }
  //           return null;
  //         },
  //         valueFormatter: (params) => {
  //           // Format the Date object to a readable string format
  //           return params.value
  //             ? format(params.value, _helper.DateFormateOrganization(true))
  //             : "";
  //         },
  //       };
  //     } else {
  //       return { ..._tempColDef };
  //     }
  //   });

  const handleCheckBoxClick = (newSelection) => {
    if (showCheckBox) {
      const _temp = [...selectedRowIds];
      if (newSelection.length === rows.length) {
        setSelectedRowIds(rows);
      } else if (newSelection.length === 0) {
        setSelectedRowIds([]);
      } else if (newSelection.length < selectedRowIds.length) {
        const filteredElements = rows.filter((element) =>
          newSelection.includes(element.id),
        );
        setSelectedRowIds(filteredElements);
      } else {
        rows.forEach((element) => {
          if (
            newSelection.includes(element.id) &&
            !_temp.some((item) => item.id === element.id)
          ) {
            _temp.push(element);
          }
        });
        setSelectedRowIds(_temp);
      }

      if (handleSelectionChange) {
        handleSelectionChange(newSelection);
      }

      setShowToolbar(newSelection.length === 0); // Hide toolbar if any checkbox is selected}
    }
  };

  return (
    <div id="dataGrid" className={gridTableHeight}>
      <DataGridPro
        density="compact"
        columns={columns}
        rows={rows}
        pagination
        localeText={{
          ...LocalizationDataGridConst(localization),
        }}
        disableRowSelectionOnClick={true}
        slots={{
          toolbar: showToolbar ? GridToolbarButton : CustomToolBar, // Conditionally render the toolbar
        }}
        checkboxSelection={showCheckBox}
        onRowSelectionModelChange={(newSelection) => {
          handleCheckBoxClick(newSelection);
        }}
        slotProps={{
          pagination: {
            labelRowsPerPage: localization.rowsPerPage,
          },
          filterPanel: { ...tableFilterProperty },
          showQuickFilter: true,
        }}
      />
    </div>
  );
};

export default CustomDataGrid;
